























import { Component, Prop, Vue } from "vue-property-decorator";
import { MiraBar } from "@/utils/MiraDataQualityView";

/**
 * Several bars per row, directly below each other and coloured by entity, under one legend for the whole
 * card (Hans, #2610112 X3: Schadenursachen in the Markt "like in time series"). The row's label sits once
 * beside its bars, so no bar repeats the entity's name; the value is printed beside every bar.
 */
@Component
export default class MiraGroupedBarRowsComponent extends Vue {
  @Prop({ required: true })
  rows!: Array<{ key: string; label: string; bars: MiraBar[] }>;

  @Prop({ required: true })
  legend!: Array<{ key: string; label: string; color: string }>;

  fillWidth(fraction: number): string {
    return `${Math.max(0, Math.min(1, fraction)) * 100}%`;
  }
}
